import { render, staticRenderFns } from "./ReportCardAdditionalInfosAdministration.vue?vue&type=template&id=01ac7409&scoped=true&"
import script from "./ReportCardAdditionalInfosAdministration.vue?vue&type=script&lang=ts&"
export * from "./ReportCardAdditionalInfosAdministration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ac7409",
  null
  
)

export default component.exports